import { render, staticRenderFns } from "./SearchPlace.vue?vue&type=template&id=a28f2950"
import script from "./SearchPlace.vue?vue&type=script&lang=js"
export * from "./SearchPlace.vue?vue&type=script&lang=js"
import style0 from "./SearchPlace.vue?vue&type=style&index=0&id=a28f2950&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a28f2950')) {
      api.createRecord('a28f2950', component.options)
    } else {
      api.reload('a28f2950', component.options)
    }
    module.hot.accept("./SearchPlace.vue?vue&type=template&id=a28f2950", function () {
      api.rerender('a28f2950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/SearchPlace.vue"
export default component.exports